import { BASE_URL } from "../constants";
import { DepartemenEntity } from "../entities/DepartemenEntity";
import FetchUtils from "../utils/fetch";

class DepartemenService {
    static async GetAllDepartemen(): Promise<DepartemenEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/departemens`);
        if (resp.status != 200) { throw resp.message }

        const data: DepartemenEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new DepartemenEntity({
                id: resp.data[i].ID,
                departemen: resp.data[i].Departemen,
            }))
        }

        return data;
    }

    static async AddDepartemen(data: { departemen: string }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/departemens/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async UpdateDepartemen(data: DepartemenEntity, fields: { departemen?: string}): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/departemens/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteDepartemen(data: DepartemenEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/departemens/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async ImportDepartemen(data: DepartemenEntity[]): Promise<{ message: string }> {
      const request = [];
      for (let i = 0; i < data.length; i++) {
        request.push({
          departemen: data[i].departemen
        })
      }
  
      const resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/departemens/import`,
        {
          method: 'POST',
          body: JSON.stringify({ batch: request })
        }
      );
      if (resp.status != 200) { throw resp.message }
  
      return resp;
    }
}

export { DepartemenService };